export const contactsData = {
    email: 'phethanicyrilmudau@gmail.com',
    phone: '+27 (82) 482 6547',
    address: 'Johannesburg, Gauteng, South Africa ',

    sheetAPI: ''
}